import { createResourceActions } from "src/redux_resources_v1";

// Error tracking
import { trackError } from "src/error_tracking";

// Analytics
import { startTimeTrack, finishTimeTrack } from "src/analytics";

// Constants
import { reduxResourceContexts } from "src/constants";

/**
 * Create a delete data and update with status by id action creator
 * @param {Object} options
 * @param {string} options.resourceName resource name
 * @param {Object} options.api api object that responds to "delete" call
 * @param {function} options.onSuccess thunk action for success case
 * @param {function} options.onError thunk action for error case
 * @param {Function} options.responseNormalizer function to override normalizing the response
 * @returns {Function} action creator for a thunk action to DELETE the resource
 */
export function createDeleteDataActionWithDeleteStatusById({
  resourceName,
  api,
  onSuccess,
  onError,
  responseNormalizer
}) {
  const analyticsEventName = `API_DELETE_${resourceName.toUpperCase()}`;
  const resourceActions = createResourceActions(resourceName);

  return ({ resource }) => {
    return dispatch => {
      dispatch(resourceActions.loadingDeleteWithStatusByIdAction(resource.id));
      startTimeTrack(analyticsEventName);

      return api
        .delete(resource)
        .then(response => {
          finishTimeTrack(analyticsEventName);

          let replaceData;
          if (response.data && responseNormalizer) {
            replaceData = responseNormalizer(response.data);
          }

          // Delete the resource
          dispatch(
            resourceActions.deleteActionWithStatusById({
              context: reduxResourceContexts.delete,
              id: resource.id,
              replaceData
            })
          );

          if (onSuccess) {
            onSuccess(dispatch);
          }
        })
        .catch(err => {
          finishTimeTrack(analyticsEventName, {
            error: true,
            errorCode: err.response ? err.response.status : undefined
          });
          trackError(err);

          if (onError) {
            onError(dispatch);
          }
        });
    };
  };
}
